<div class="p-4">
  <p-toast></p-toast>
  <p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>
  <div class="loader-overlay" *ngIf="isLoading">
    <p-progress-spinner ariaLabel="loading" />
  </div>

  <div class="card bg-white border-round">
    <div class="card-header p-3 ml-auto border-bottom-1 border-gray-200">
      <div class="flex w-full items-center">
        <h2 class="m-0">Claim Contract</h2>
      </div>
      <div class="flex justify-content-end gap-2">
        <p-button
          label="Search"
          icon="pi pi-check"
          (click)="submitForm()"
          [loading]="isLoading"
        ></p-button>
        <p-button
          label="Export"
          icon="pi pi-file-excel"
          styleClass="p-button-help"
          (click)="exportExcel()"
        ></p-button>
      </div>
    </div>
    <div class="card-body p-2">
      <form
        [formGroup]="filterForm"
        novalidate
        autocomplete="off"
        autocorrect="off"
        autocapitalize="off"
        spellcheck="off"
      >
        <div class="grid formgrid p-fluid">
          <!-- Claim No -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon>
                <i class="pi pi-file"></i>
              </p-inputgroup-addon>
              <p-iftalabel>
                <input
                  type="text"
                  pInputText
                  formControlName="claimContractNo"
                  inputId="claimContractNo"
                  class="w-full"
                  placeholder="Enter Claim Contract No"
                />
                <label for="claimContractNo">Claim No</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>
         
           <!-- activity type -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-briefcase"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-dropdown
                  [options]="filteredActivityTypes"
                  formControlName="activityType"
                  inputId="activityType"
                  styleClass="w-full"
                  [filter]="true"
                  [fluid]="true"
                  [panelStyle]="{ width: '70%' }"
                >
                  <ng-template let-activityType pTemplate="selectedItem">
                    <div *ngIf="activityType">
                      {{ activityType.name }}
                    </div>
                  </ng-template>
                  <ng-template let-activityType pTemplate="item">
                    <div>
                      {{ activityType.name }}
                    </div>
                  </ng-template>
                  <ng-template pTemplate="filter" let-activityType>
                    <p-inputgroup>
                      <p-inputgroup-addon>
                        <i class="pi pi-search"></i>
                      </p-inputgroup-addon>
                      <input
                        #activityTypeInput
                        type="text"
                        pInputText
                        placeholder="Filter"
                        (keyup)="filterActivityTypes($event)" 
                        value="{{ activityTypefilterValue }}"
                      />
                      <!-- <p-button
                        type="button"
                        icon="pi pi-times"
                        (click)="filterForm.controls['activityType'].reset(); filteredActivityTypes = activityTypes; activityTypeInput.value = ''"
                        styleClass="p-button-secondary"
                      ></p-button> -->
                    </p-inputgroup>
                  </ng-template>
                </p-dropdown>
                <label for="activityType">Activity Type</label>
              </p-iftalabel>
              <p-inputgroup-addon>
                <p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['activityType'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button>
              </p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <!-- business  -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-briefcase"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-dropdown
                  [options]="filteredBusinesses"
                  formControlName="business"
                  inputId="business"
                  styleClass="w-full"
                  [filter]="true"
                  [fluid]="true"
                  [panelStyle]="{ width: '70%' }"
                >
                  <ng-template let-business pTemplate="selectedItem">
                    <div *ngIf="business">
                      {{ business.businessCode }} -
                      {{ business.businessName }}
                    </div>
                  </ng-template>
                  <ng-template let-business pTemplate="item">
                    <div>
                      {{ business.businessCode }} -
                      {{ business.businessName }}
                    </div>
                  </ng-template>
                  <ng-template pTemplate="filter" let-business>
                    <p-inputgroup>
                      <p-inputgroup-addon>
                        <i class="pi pi-search"></i>
                      </p-inputgroup-addon>
                      <input
                        #businessInput
                        type="text"
                        pInputText
                        placeholder="Filter"
                        (keyup)="filterBusinesses($event)"
                        value="{{ BusinessfilterValue }}"
                      />
                      <!-- <p-button
                        type="button"
                        icon="pi pi-times"
                        (click)="filterForm.controls['business'].reset(); filteredBusinesses = businesses; businessInput.value = ''"
                        styleClass="p-button-secondary"
                      ></p-button> -->
                    </p-inputgroup>
                  </ng-template>
                </p-dropdown>
                <label for="business">Business</label>
              </p-iftalabel>
              <p-inputgroup-addon>
                <p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['business'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button>
              </p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <!-- supplier required -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-briefcase"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-dropdown
                  [options]="filteredSuppliers"
                  formControlName="supplier"
                  inputId="supplier"
                  styleClass="w-full"
                  [filter]="true"
                  [fluid]="true"
                  [panelStyle]="{ width: '70%' }"
                >
                  <ng-template let-supplier pTemplate="selectedItem">
                    <div *ngIf="supplier">
                      {{ supplier.supplierNumber }} -
                      {{ supplier.supplierName }}
                    </div>
                  </ng-template>
                  <ng-template let-supplier pTemplate="item">
                    <div>
                      {{ supplier.supplierNumber }} -
                      {{ supplier.supplierName }}
                    </div>
                  </ng-template>
                  <ng-template pTemplate="filter" let-supplier>
                    <p-inputgroup>
                      <p-inputgroup-addon>
                        <i class="pi pi-search"></i>
                      </p-inputgroup-addon>
                      <input
                        #supplierInput
                        type="text"
                        pInputText
                        placeholder="Filter"
                        (keyup)="filterSuppliers($event)"
                        value="{{ SupplierfilterValue }}"
                      />                    
                    </p-inputgroup>
                  </ng-template>
                </p-dropdown>
                <label for="supplier">Supplier</label>
              </p-iftalabel>
              <p-inputgroup-addon>
                <p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['supplier'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button>
              </p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <!--  Type required -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon>
                <i class="pi pi-building"></i>
              </p-inputgroup-addon>
              <p-iftalabel>
                <p-dropdown
                  [fluid]="true"
                  [options]="discountTypes"
                  formControlName="discountType"
                  optionLabel="label"
                  optionValue="value"
                  inputId="discountType"
                  class="w-full"
                  placeholder="Select Contract Type"
                ></p-dropdown>
                <label for="discountType">Contract Type</label>
              </p-iftalabel>
              <p-inputgroup-addon>
                <p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['discountType'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button>
              </p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <!-- start date required -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-calendar"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-datePicker
                  formControlName="startDate"
                  [showIcon]="true"
                  inputId="startDate"
                  class="w-full"
                  [appendTo]="'body'"
                  [style]="{ width: '100%' }"
                ></p-datePicker>
                <label for="startDate">Start Date</label>
              </p-iftalabel>
              <p-inputgroup-addon>
                <p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['startDate'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button>
              </p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <!-- end date requird -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-calendar"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-datePicker
                  formControlName="endDate"
                  [showIcon]="true"
                  inputId="endDate"
                  class="w-full"
                  [appendTo]="'body'"
                  [style]="{ width: '100%' }"
                  [minDate]="filterForm.get('startDate')?.value"
                ></p-datePicker>
                <label for="endDate">End Date</label>
              </p-iftalabel>
              <p-inputgroup-addon>
                <p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['endDate'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button>
              </p-inputgroup-addon>
            </p-inputgroup>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="card mt-2">
    <p-table
      #dt
      [value]="claimContracts"
      [rows]="10"
       [paginator]="true"
      [paginatorDropdownAppendTo]="'body'"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [rowsPerPageOptions]="[25, 50, 100, 500]" 
      [totalRecords]="totalRecords"
      (onLazyLoad)="loadClaimContracts($event)"
      [loading]="isLoading"
      [lazy]="true"
      dataKey="id"
      styleClass="p-datatable-striped overflow-x-auto"
    >
      <ng-template pTemplate="caption">
        <div class="flex w-full items-center">
          <h2 class="m-0">Claim Contracts</h2>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="claimNumber">
            Claim Number <p-sortIcon field="claimNumber"></p-sortIcon>  
          </th>
          <th>Activity Type</th>
          <th>Supplier Name</th>
          <th>Supplier Number</th>
          <th>Business Name</th>
          <th>Business Number</th>
          <!-- <th>Supplier Site Number</th> -->
          <th>Discount Type</th>
          <th>Claim Percent</th>
          <th>Start Date</th>
          <th>End Date</th>
          <th>Creation Date</th>
          <th>Created By</th>
          <!-- <th style="width: 10rem">Actions</th> -->
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-claim>
        <tr>
          <td>{{ claim.claimContractNo }}</td>
          <td>{{ claim.activityType.name ?? null }}</td>       
          <td>{{ claim.supplier.supplierName ?? null }}</td>
          <td>{{ claim.supplier.supplierNumber ?? null }}</td>
          <td>{{ claim.business.businessName ?? null }}</td>
          <td>{{ claim.business.businessCode ?? null }}</td>
          <!-- <td>{{ claim.vendorSite.supplierSiteNumber ?? null }}</td>  -->
          <td>{{ claim.discountType ?? null }}</td>
          <td>{{ claim.claimPercent ?? null }}</td>
          <td>{{ claim.startDate ?? null }}</td>
          <td>{{ claim.endDate ?? null }}</td>
          <td>{{ claim.createdAt | appDate:'dd-MM-yyyy' }}</td>
          <td>{{ claim.createdBy?.fullName ?? null }}</td>
          <td>
            <div class="flex gap-2">
              <!-- <p-button
                icon="pi pi-eye"
                styleClass="p-button-rounded p-button-info p-button-outlined"
                (onClick)="ViewContractClaim(claim)"
              ></p-button> -->
              <!-- <p-button
                icon="pi pi-pencil"
                styleClass="p-button-rounded p-button-success"
                (onClick)="EditContractClaim(claim)"
              ></p-button> -->
              <!-- <p-button
                icon="pi pi-trash"
                styleClass="p-button-rounded p-button-danger"
                (onClick)="deleteContract(customer.id)"
              ></p-button> -->
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4">No Claims found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  
</div>
